module.exports = __webpack_public_path__ + "static/media/1.9d8ee8cc.jpeg";